import React from "react";

export default function MobileBulkSelectionBar({
    selectionMode,
    selectedCount,
    approvalMode,
    hasTransactions,
    onEnterSelectionMode,
    onSelectAll,
    onClearSelection,
    onBulkEdit,
    onBulkApprove
}) {
    if (selectionMode) {
        // Selection Mode Active - Show action bar
        return (
            <div style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "white",
                boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.15)",
                padding: "15px 20px",
                zIndex: 999,
                direction: "rtl"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px"
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                            {selectedCount} נבחרו
                        </span>
                        <button
                            onClick={onSelectAll}
                            style={{
                                padding: "6px 12px",
                                fontSize: "13px",
                                border: "1px solid #007BFF",
                                backgroundColor: "white",
                                color: "#007BFF",
                                borderRadius: "6px",
                                cursor: "pointer"
                            }}
                        >
                            בחר הכל
                        </button>
                    </div>
                    <button
                        onClick={onClearSelection}
                        style={{
                            padding: "6px 12px",
                            fontSize: "13px",
                            border: "1px solid #6C757D",
                            backgroundColor: "white",
                            color: "#6C757D",
                            borderRadius: "6px",
                            cursor: "pointer"
                        }}
                    >
                        ביטול
                    </button>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                    <button
                        onClick={onBulkEdit}
                        style={{
                            flex: 1,
                            padding: "12px",
                            fontSize: "15px",
                            fontWeight: "bold",
                            border: "none",
                            backgroundColor: "#FFC107",
                            color: "white",
                            borderRadius: "8px",
                            cursor: "pointer"
                        }}
                    >
                        ערוך
                    </button>
                    <button
                        onClick={onBulkApprove}
                        style={{
                            flex: 1,
                            padding: "12px",
                            fontSize: "15px",
                            fontWeight: "bold",
                            border: "none",
                            backgroundColor: "#28A745",
                            color: "white",
                            borderRadius: "8px",
                            cursor: "pointer"
                        }}
                    >
                        אשר הכל
                    </button>
                </div>
            </div>
        );
    }

    // Selection mode is entered by long-pressing a transaction, so no floating
    // button is needed here.
    return null;
}